import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertBranch from "../../../components/branchComponent/insertBranch";
import { translate } from "react-i18next";
import ReadAxios from "../../../components/axiosComponent/read";

class AddBranches extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "add_title",
      editData: {},
    };
  }

  async componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      let LrSeriesData = {}
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
      this.props.location.state.branchId && this.getLRSeriesData(this.props.location.state.branchId)
    }
  }

  getLRSeriesData= async(branchId)=>{
    await ReadAxios({completeURL:`${process.env.REACT_APP_MASTER_API}/branchLrSeriesMapping?branchId=${branchId}`}).then((res)=>{
      let LrSeriesData =  res.data.resultSet.length > 0 ? res.data.resultSet : []
      this.setState({
        LrSeriesData
      })
    }).catch((err)=>{
      console.log(err);
    })
  }

  onFormSubmit = () => {
    this.props.history.push("/branch");
    this.props.history.go();
  };

  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.state.editData.branchId?"Edit Branch":"Add Branch"} LinkName="/branch" />
        <div className="m-2">
          <InsertBranch
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
            LrSeriesData={this.state.LrSeriesData}
          />
        </div>
      </React.Fragment>
    );
  }
}

export default translate("allbranch")(AddBranches);
